var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Basics / Borrar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.626,0 24,5.374 24,12 C24,18.626 18.627,24 12,24 C5.374,24 0,18.626 0,12 C0,5.374 5.373,0 12,0 Z M16.9497,15.5361 L13.4137,12.0001 L16.9497,8.4641 C17.3407,8.0731 17.3407,7.4411 16.9497,7.0511 C16.5587,6.6601 15.9267,6.6601 15.5357,7.0511 L11.9997,10.5861 L8.4647,7.0511 C8.0737,6.6601 7.4407,6.6601 7.0507,7.0511 C6.6597,7.4411 6.6597,8.0731 7.0507,8.4641 L10.5857,12.0001 L7.0507,15.5361 C6.6597,15.9271 6.6597,16.5581 7.0507,16.9491 C7.4407,17.3401 8.0737,17.3401 8.4647,16.9491 L11.9997,13.4141 L15.5357,16.9491 C15.9267,17.3401 16.5587,17.3401 16.9497,16.9491 C17.3407,16.5581 17.3407,15.9271 16.9497,15.5361 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Basics-/-Borrar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-White",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRemove);
export default __webpack_public_path__ + "static/media/img-remove.c077117277f4fc271d7ac23762dfe24e.svg";
export { ForwardRef as ReactComponent };